import { render, staticRenderFns } from "./QuickViewSection.vue?vue&type=template&id=4b33f6ad&scoped=true"
import script from "./QuickViewSection.vue?vue&type=script&lang=js"
export * from "./QuickViewSection.vue?vue&type=script&lang=js"
import style0 from "./QuickViewSection.vue?vue&type=style&index=0&id=4b33f6ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b33f6ad",
  null
  
)

export default component.exports